import { formatValidQueryParamUrlCommaSeparated } from "utils/common";
import {
  formatEventsResponse,
  formatEventsSearchResponse
} from "utils/events.util";

import { emptySplitApi } from "./empty-split-api";
import {
  type EventFilters,
  type EventSearchOption,
  type Events,
  type EventsResponse
} from "./types/events.type";

export const EMPTY_STAFF_ID = -1;

export const eventsApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getEvents: builder.query<Events, EventFilters>({
      query: (filters) =>
        `/events-optimized/?${formatValidQueryParamUrlCommaSeparated({
          ...filters.baseFilter,
          from_date: filters.fromDate,
          to_date: filters.toDate,
          query: filters.query,
          clinic: filters.clinicIds,
          staff_member: filters.staffIds,
          type: filters.eventType,
          search: filters.search && encodeURIComponent(filters.search),
          assigned_tags: filters.assigned_tags
        })}`,
      providesTags: ["Events"],
      transformResponse: (response: EventsResponse) => {
        return formatEventsResponse(response);
      }
    }),
    searchEvents: builder.query<EventSearchOption[], EventFilters>({
      query: (filters) =>
        `/events-optimized/?${formatValidQueryParamUrlCommaSeparated({
          ...filters.baseFilter,
          from_date: filters.fromDate,
          to_date: filters.toDate,
          query: filters.query,
          clinic: filters.clinicIds,
          staff_member: filters.staffIds,
          type: filters.eventType,
          search: filters.search && encodeURIComponent(filters.search),
          ordering: filters.ordering,
          limit: filters.limit
        })}`,
      providesTags: ["Events"],
      transformResponse: (response: EventsResponse) => {
        return formatEventsSearchResponse(response);
      }
    })
  })
});

export const { useGetEventsQuery, useSearchEventsQuery } = eventsApi;
